import DRE from './dre';
import DREContainer from './dre.container';
export default DREContainer(DRE);
//# sourceMappingURL=index.js.map